import React from "react";
import { Button, Modal } from "../ui";
import { shareCode, shareUrl } from "../../services/api-content";
import { useToast } from "../../context/ToastContext";

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand?.("copy");
    ta.remove();
    return !!ok;
  }
};

export default function ShareModal({ open, onClose, character }) {
  const toast = useToast();
  if (!character) return null;
  const url = shareUrl(character.id);
  const code = shareCode(character);
  const copy = async (text, label) => toast((await copyText(text)) ? `คัดลอก${label}แล้ว` : "คัดลอกไม่สำเร็จ ลองกดค้างที่ข้อความ", "success");
  const native = typeof navigator !== "undefined" && navigator.share;
  return (
    <Modal open={open} onClose={onClose} title="แชร์ตัวละคร" size="sm">
      <div className="stack">
        <div><div className="faint" style={{ fontSize: 12 }}>ลิงก์</div><div className="card" style={{ wordBreak: "break-all", fontSize: 13 }}>{url}</div></div>
        <Button onClick={() => copy(url, "ลิงก์")}>คัดลอกลิงก์</Button>
        <div><div className="faint" style={{ fontSize: 12 }}>โค้ดแชร์ (ให้เพื่อนใส่ที่หน้าค้นหา)</div><div className="card center" style={{ fontSize: 22, fontWeight: 800, letterSpacing: 3, wordBreak: "break-all" }}>{code}</div></div>
        <Button onClick={() => copy(code, "โค้ด")}>คัดลอกโค้ด</Button>
        {native ? <Button variant="primary" onClick={() => navigator.share({ title: character.name, text: character.tagline, url }).catch(() => {})}>แชร์ผ่านแอปอื่น</Button> : null}
      </div>
    </Modal>
  );
}
